import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import ApiService from "../../util/ApiService";
import Select from "react-select";
import Switch from "react-switch"; // Importando o JS do Bootstrap


const GuideEditModal = ({ show, onHide, guide, actionText = "Salvar" }) => {
    const fileAccept = ".jpg,.jpeg,.png,.gif,.webp";
    const [options, setOptions] = useState([]);
    const [file, setFile] = useState("");
    const [guideData, setGuideData] = useState({
        id: "",
        name: "",
        title: "",
        section_title: "",
        image_url: "",
        url: "",
        description: "",
        status: 1,
        guide_user_category_id: null
    });

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (guide?.id) {
            setGuideData(guide);
        } else {
            setGuideData({
                id: "",
                name: "",
                title: "",
                section_title: "",
                image_url: "",
                url: "",
                description: "",
                status: 1,
                guide_user_category_id: null
            });
        }
    }, [guide]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setGuideData({ ...guideData, [name]: value });
    };


    const handleChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const convertImagesToBase64 = async (html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const images = div.querySelectorAll("img");

        const promises = Array.from(images).map(async (img) => {
            const response = await fetch(img.src);
            const blob = await response.blob();

            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    img.src = reader.result; // substitui a URL por base64
                    resolve();
                };
                reader.readAsDataURL(blob);
            });
        });

        await Promise.all(promises);
        return div.innerHTML;
    };


    const fetchCategories = async () => {
        try {

            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}guide-user/list-categories`, // Altere conforme o endpoint real
                {},
                true
            );

            const { data } = ApiService.handleApiResponse(response);

            const companyOptions = data.map((company) => ({
                value: company.id,
                label: company.name,
            }));

            setOptions(companyOptions);
        } catch (error) {
            ApiService.handleApiError(error);
        }
    };



    useEffect(() => {
        fetchCategories();
    }, []);

    const handleSave = async () => {
        setLoading(true);
        try {
            const descriptionWithBase64 = await convertImagesToBase64(guideData.description);

            const formData = new FormData();

            // Campos do formulário
            formData.append('id', guideData.id || '');
            formData.append('name', guideData.name || '');
            formData.append('title', guideData.title || '');
            formData.append('section_title', guideData.section_title || '');
            formData.append('url', guideData.url || '');
            formData.append('description', descriptionWithBase64 || '');
            formData.append('status', guideData.status || '0');
            formData.append('guide_user_category_id', guideData.guide_user_category_id || '');

            // Campo de imagem (caso tenha)
            if (file) {
                formData.append('file', file);
            }

            const response = await ApiService.sendArquivo(
                "post",
                `${process.env.REACT_APP_URL_API}guide-user/register`,
                formData,
                true
            );

            if (response?.code === 200) {
                Swal.fire("Sucesso", "Guia salvo com sucesso!", "success").then(() => {
                    onHide(true);
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, false] }],
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link', 'image'],  // permite inserir imagem via URL
            ['clean']
        ]
    };
    return (
        <Modal show={show} onHide={onHide} centered size="xl">
            <Modal.Header closeButton>
                <Modal.Title>{guide?.id ? "Editar Usuário" : "Cadastrar Guia Usuário"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className=" p-3">
                    <div className="mb-3">
                        <label className="form-label">Título</label>
                        <input
                            type="text"
                            className="form-control"
                            name="title"
                            value={guideData.title}
                            onChange={handleInputChange}
                            placeholder="Digite o título do guia"
                        />
                    </div>
                    <div className="row">
                        <div className="col-9">
                            <div className="mb-3">
                                <label htmlFor="formFile" className="form-label">Imagem de Capa</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    id="formFile"
                                    onChange={handleChange}
                                    accept={fileAccept}
                                    required
                                />
                            </div>

                        </div>
                        <div className="col-3">
                            <div className="card border mb-3 p-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h6 className="mb-1">Situação</h6>
                                        <p className="text-muted mb-0" style={{fontSize: '0.85rem'}}>
                                            {guideData.status === 1 ? "Ativo" : "Inativo"}
                                        </p>
                                    </div>
                                    <Switch
                                        onChange={(checked) =>
                                            setGuideData({...guideData, status: checked ? "1" : "0"})
                                        }
                                        checked={guideData.status === 1}
                                        onColor="#0d6efd"
                                    />
                                </div>
                            </div>


                        </div>
                    </div>


                    <div className="mb-3">
                        <label className="form-label">Título da Seção</label>
                        <input
                            type="text"
                            className="form-control"
                            name="section_title"
                            value={guideData.section_title}
                            onChange={handleInputChange}
                            placeholder="Digite o título da seção"
                        />
                    </div>

                    <div className="mb-3">
                        <label className="form-label">URL</label>
                        <input
                            type="text"
                            className="form-control"
                            name="url"
                            value={guideData.url}
                            onChange={handleInputChange}
                            placeholder="Digite a URL do guia (única)"
                        />
                    </div>

                    <div className="col-md-6">
                        <div className="form-group">
                            <label>Categorias</label>
                            <Select
                                id="companySelect"
                                classNamePrefix="react-select"
                                options={options}
                                value={options.find(opt => opt.value === guideData.guide_user_category_id) || null}
                                placeholder="Selecione..."
                                onChange={(selectedOption) =>
                                    setGuideData({
                                        ...guideData,
                                        guide_user_category_id: selectedOption ? selectedOption.value : null
                                    })
                                }
                                isClearable
                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999
                                    }), // Definindo z-index alto
                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                }}
                            />

                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Descrição</label>
                        <ReactQuill
                            theme="snow"
                            modules={modules}
                            value={guideData.description}
                            onChange={(value) => setGuideData({...guideData, description: value})}
                            placeholder="Digite uma descrição com formatação e imagens via URL"
                        />
                    </div>

                </div>

                <div className="d-flex justify-content-end mt-3">
                    <button className="btn btn-dark ms-2" type="button" onClick={() => onHide()} disabled={loading}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button className="btn btn-info ms-2" type="button" onClick={() => handleSave()} disabled={loading}>
                        {loading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                            <i className="fa fa-plus me-2"></i> {actionText}
                            </>
                        )}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default GuideEditModal;
